import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mHead",
    class: _vm.isMobile && 'wap'
  }, [_vm._m(0), _c('div', {
    staticClass: "mHead-main"
  }, [_c('div', {
    staticClass: "mHead-base",
    on: {
      "click": () => _vm.$router.push('/center')
    }
  }, [_c('div', {
    staticClass: "mHead__head"
  }, [_vm.userInfo.avatar ? _c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  }) : _c('m-head-img', {
    attrs: {
      "name": _vm.userInfo,
      "bgColor": _vm.userInfo.head_color
    }
  })], 1), _c('div', {
    staticClass: "mHead-info"
  }, [_c('div', {
    staticClass: "mHead__name"
  }, [_vm._v(_vm._s(_vm.userInfo.nickname))]), _c('div', {
    staticClass: "mHead__level"
  }, [_c('span', {
    staticClass: "level"
  }, [_vm._v("LV: " + _vm._s(_vm.userInfo.user_level))]), _c('span', {
    staticClass: "vip"
  }, [_vm._v("VIP: " + _vm._s(_vm.userInfo.vip_level))])])])]), _c('div', {
    staticClass: "mHead-balance"
  }, [_c('div', {
    staticClass: "mHead-balance-item",
    on: {
      "click": function ($event) {
        !_vm.choiceLoading && _vm.onDiamondShow();
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "diamondBalanceId",
      "src": require(`@images/${_vm.aiSkin}/icon-diamond.png`),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.diamond)))]), _vm.choiceLoading ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]) : _vm._e()]), _c('div', {
    staticClass: "mHead-balance-item",
    on: {
      "click": () => _vm.$router.push('/pass')
    }
  }, [_c('img', {
    attrs: {
      "id": "coinBalanceId",
      "src": require(`@images/${_vm.aiSkin}/icon-coin.png`),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.coin)))])])])]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "popBuyDiamondClass",
      "show": _vm.popBuyDiamindShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popBuyDiamindShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-buyDiamond"
  }, [_c('div', {
    staticClass: "pop-buyDiamond__title"
  }, [_vm._v("Diamond")]), _c('div', {
    staticClass: "pop-buyDiamond-list"
  }, [_c('transition-group', {
    staticClass: "pop-buyDiamond-scroll",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, [_vm.diamondPriceList && !_vm.isBuyTicketListLoading ? _vm._l(_vm.diamondPriceList, function (item, index) {
    return _c('div', {
      key: `mp${index}`,
      staticClass: "pop-buyDiamond-item off",
      class: [index == 3 && 'popular', index == _vm.diamondPriceList.length - 1 && 'best'],
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      }
    }, [index == 3 || _vm.diamondPriceList.length - 1 == index ? _c('div', {
      staticClass: "pop-buyDiamond-item-tag"
    }, [index == 3 ? [_vm._v("POPULAR")] : _vm._e(), index == _vm.diamondPriceList.length - 1 ? [_vm._v("BEST DEAL")] : _vm._e()], 2) : _vm._e(), _c('div', {
      staticClass: "pop-buyDiamond-item-main"
    }, [_c('div', {
      staticClass: "pop-buyDiamond-item__num"
    }, [_vm._v(_vm._s(_vm.fmt_pre(item.diamond - item.bonus)))]), _c('div', {
      staticClass: "pop-buyDiamond-item_head"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/diamond/${index >= 8 ? 8 : index + 1}.png`),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "pop-buyDiamond-item__sub"
    }, [item.off ? _c('span', [_vm._v(_vm._s(item.off))]) : _vm._e()]), _c('div', {
      staticClass: "pop-buyDiamond-item-info",
      on: {
        "click": function ($event) {
          return _vm.onPayTicket(item);
        }
      }
    }, [_c('div', {
      staticClass: "pop-buyDiamond-item-info__price"
    }, [!item.isLoading ? [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/icon-star.png`),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(item.stars)))])] : [_c('div', {
      staticClass: "circleLoading"
    })]], 2)])])]);
  }) : _vm._e()], 2)], 1)])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mHead-dec"
  }, [_c('span')]);
}];
export { render, staticRenderFns };